import { PhoneCall, ClipboardCheck, Truck } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "@/lib/contact";

const STEPS = [
    {
        n: "01",
        icon: PhoneCall,
        title: "Get in touch",
        body: (
            <>
                Call{" "}
                <a
                    href={PHONE_HREF}
                    className="underline underline-offset-4 decoration-tp-gold decoration-2 hover:text-tp-forest"
                    data-testid="how-it-works-inline-call"
                >
                    {PHONE_DISPLAY}
                </a>{" "}
                or send the quick quote form with your suburb, bin size and
                waste type.
            </>
        ),
    },
    {
        n: "02",
        icon: ClipboardCheck,
        title: "We confirm your quote",
        body: (
            <>
                We lock in your price and delivery time — no surprises, no
                hidden extras.
            </>
        ),
    },
    {
        n: "03",
        icon: Truck,
        title: "We deliver and collect",
        body: (
            <>
                Your bin arrives same day or next day where available. You
                fill it, we take it away and dispose of it responsibly.
            </>
        ),
    },
];

export const HowItWorks = () => {
    return (
        <section
            id="how-it-works"
            data-testid="section-how-it-works"
            className="py-14 md:py-20 bg-white border-y border-tp-forest/10"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl tp-reveal">
                    <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-tp-forest font-semibold">
                        <span className="h-1.5 w-1.5 rounded-full bg-tp-gold" />
                        How it works
                    </div>
                    <h2 className="mt-3 font-heading text-3xl md:text-4xl text-tp-forest leading-tight">
                        Three simple steps to a clean site
                    </h2>
                    <p className="mt-3 text-sm md:text-base text-tp-ink/80">
                        Straightforward from quote to collection. No paperwork games, no
                        chasing calls back.
                    </p>
                </div>

                <ol className="mt-8 md:mt-10 grid gap-4 md:gap-6 md:grid-cols-3">
                    {STEPS.map((s) => (
                        <li
                            key={s.n}
                            data-testid={`how-it-works-step-${s.n}`}
                            className="tp-reveal relative bg-tp-offwhite rounded-2xl p-5 md:p-6 border border-tp-forest/10 overflow-hidden"
                        >
                            <div className="absolute -top-2 -right-2 font-heading text-6xl text-tp-gold/25 select-none pointer-events-none leading-none">
                                {s.n}
                            </div>
                            <span className="inline-flex items-center justify-center h-11 w-11 rounded-lg bg-white ring-1 ring-tp-gold/50">
                                <s.icon size={22} strokeWidth={2.2} className="text-tp-forest" />
                            </span>
                            <div className="mt-3 text-[11px] uppercase tracking-[0.16em] text-tp-forest/80 font-semibold">
                                Step {s.n}
                            </div>
                            <h3 className="mt-1 font-heading text-xl md:text-2xl text-tp-forest leading-tight">
                                {s.title}
                            </h3>
                            <p className="mt-2 text-sm text-tp-ink/85 relative z-10">{s.body}</p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
};

export default HowItWorks;
